import { render, staticRenderFns } from "./Refund1Page.vue?vue&type=template&id=24220f2a"
import script from "./Refund1Page.vue?vue&type=script&lang=js"
export * from "./Refund1Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports